import { render, staticRenderFns } from "./Manufacturing.vue?vue&type=template&id=49854030"
import script from "./Manufacturing.vue?vue&type=script&lang=js"
export * from "./Manufacturing.vue?vue&type=script&lang=js"
import style0 from "./Manufacturing.vue?vue&type=style&index=0&id=49854030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports